import {DTDistributionNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {toAiOutputType} from '../aiModels/cardDetailsAI.enums';
import {getBaseHeader, getDestinationPhrase, getOutputIdentifier} from './utils';

export function distributionCardToText(card: DTDistributionNode, mode: 'short' | 'full'): string {
  const header = getBaseHeader(card);

  if (mode === 'short') {
    const outputLines = card.outputs.map((output) => {
      const outputId = getOutputIdentifier(output);
      const dest = getDestinationPhrase(output.nodeId);

      return `Output ${outputId} ${dest}`;
    });

    return [header, ...outputLines].join('\n');
  }

  const outputLines = card.outputs.map((output) => {
    const outputId = getOutputIdentifier(output);
    const dest = getDestinationPhrase(output.nodeId);
    const typeLabel = toAiOutputType(output.type) ?? '';

    return `Output ${outputId} ${dest} type=${typeLabel}`;
  });

  return [header, ...outputLines].join('\n');
}
